// extracted by mini-css-extract-plugin
module.exports = {"oneOnOneYogaPage":"OneOnOneYogaPage_oneOnOneYogaPage__jV9wk","certifiedInstructors":"OneOnOneYogaPage_certifiedInstructors__GmLVk"};